import * as A from './types';
import axios from 'axios';
import * as ResultHelpers from '../../helpers/results';
import _ from 'lodash';

export const updateAge = age => ({ type: A.UPDATE_AGE, age });
export const selectMedicare = medicareYN => ({ type: A.SELECT_MEDICARE, medicareYN });
export const selectBudget = (budget) => ({ type: A.SELECT_BUDGET, budget });
export const selectTravel = (travel) => ({ type: A.SELECT_TRAVEL, travel });
export const updateHouseholdSize = householdSize => ({ type: A.UPDATE_HOUSEHOLD_SIZE, householdSize });
export const updateKidsCount = kidsCount => ({ type: A.UPDATE_KIDS_COUNT, kidsCount });
export const updateIncome = income => ({ type: A.UPDATE_INCOME, income });
export const updateFullTimeEmployees = numOfEmployees => ({ type: A.UPDATE_EMPLOYEE_COUNT, numOfEmployees });
export const selectEmployeeBudget = employeeBudget => ({ type: A.SELECT_EMPLOYEE_BUDGET, employeeBudget });
export const selectEmployeePref = employeePref => ({ type: A.SELECT_EMPLOYEE_PREF, employeePref });
export const updateQuote = quote => ({ type: A.UPDATE_QUOTE, quote });
export const resetQuote = quote => ({ type: A.RESET_QUOTE });
export const setResults = results => ({ type: A.SET_RESULTS, results });
export const changeSelectedPlan = (planObj) => ({ planObj, 'type': A.CHANGE_SELECTED_PLAN, 'planId': planObj.PlanId });
export const setStep = step => ({ type: A.SET_STEP, step });
export const startOver = () => ({ type: A.START_OVER });
export const restRequest = (type, response, opts) => ({ response, type, opts });
export const setFieldValue = (fieldKey, fieldValue) => ({ type: A.SET_FIELD_VALUE, fieldKey, fieldValue });
export const setVisibility = (key, value) => ({ type: A.SET_VISIBILITY, key, value });

export const toggleInQuiz = state => ({ type: A.TOGGLE_IN_QUIZ, state });
export const toggleInResults = state => ({ type: A.TOGGLE_IN_RESULTS, state });
export const updateTopBanner = topBanner => ({ type: A.UPDATE_TOP_BANNER, topBanner });
export const updateHeaderHours = hours => ({ type: A.UPDATE_HEADER_HOURS, hours });
export const updateHeaderPhone = phone => ({ type: A.UPDATE_HEADER_PHONE, phone });
export const updateHeaderPremium = premium => ({ type: A.UPDATE_HEADER_PREMIUM, premium });
export const updateHeaderScroller = scrollButton => ({ type: A.UPDATE_HEADER_SCROLLER, scrollButton });
export const updateResultsRatings = (ratings, ratingsProps) => ({ type: A.UPDATE_RESULTS_RATINGS, ratings, ratingsProps });
export const updateResultsFooter = (footer, footerProps) => ({ type: A.UPDATE_RESULTS_FOOTER, footer, footerProps });

export const updateZip = ({ zip, county } = {}) => ({
  type: A.UPDATE_ZIP,
  zip,
  county
});

export const selectFamilyType = (famType, isOriginal) => ({
  type: A.SELECT_FAMILY_TYPE,
  famType,
  isOriginal
});

export const fetchCounties = ({ dispatch }) => {
  return axios.get(`${process.env.REACT_APP_API_URL}/counties`)
    .then(response => (dispatch(restRequest(A.FETCH_COUNTIES, response))))
    .catch(response => (dispatch(restRequest(A.FAIL_REST_REQUEST, response))));
};

export const postResults = ({ dispatch, results, url }) => { // url: 'individual'/'group'/'medicare'
  const refinedValues = _.clone(ResultHelpers.formatFieldValuesForEndpoint(results));
  return axios.post(`${process.env.REACT_APP_API_URL}/plans/${url}`, refinedValues)
    // .then(response => (dispatch(restRequest(A.SET_RESULTS, response, {results: refinedValues}))))
    .then(response => {
      return dispatch(restRequest(A.SET_RESULTS, response, {results: refinedValues}));
    })
    .catch(response => (dispatch(restRequest(A.FAIL_REST_REQUEST, response))));
};



// WEBPACK FOOTER //
// ./src/redux/actions/index.js